// lib/user-management/route-catalog.ts
// Single source of route checkboxes for Staff Access settings.
// Keep in sync with operations layout NAV_ITEMS + ADMIN_ROUTES.

export type AdminRouteCatalogItem = {
  id: string;
  label: string;
  path: string;
  group: "sidebar" | "admin_routes";
};

/** Top-level grantable prefixes shown in the invite/edit checklist. */
export const ADMIN_ROUTE_CATALOG: readonly AdminRouteCatalogItem[] = [
  // Sidebar
  {
    id: "overview",
    label: "Overview",
    path: "/admin/operations",
    group: "sidebar",
  },
  {
    id: "this-week",
    label: "This Week",
    path: "/admin/operations/this-week",
    group: "sidebar",
  },
  {
    id: "mission-control",
    label: "Mission Control",
    path: "/admin/operations/mission-control",
    group: "sidebar",
  },
  {
    id: "brain",
    label: "Brain",
    path: "/admin/operations/brain",
    group: "sidebar",
  },
  {
    id: "brain-calls",
    label: "Brain · Calls",
    path: "/admin/operations/brain/calls",
    group: "sidebar",
  },
  {
    id: "code-reviews",
    label: "Code Reviews",
    path: "/admin/operations/code-reviews",
    group: "sidebar",
  },
  {
    id: "goals",
    label: "Goals",
    path: "/admin/operations/goals",
    group: "sidebar",
  },
  {
    id: "tasks",
    label: "Tasks",
    path: "/admin/operations/tasks",
    group: "sidebar",
  },
  {
    id: "content",
    label: "Content",
    path: "/admin/operations/content",
    group: "sidebar",
  },
  {
    id: "gtm",
    label: "GTM",
    path: "/admin/operations/gtm",
    group: "sidebar",
  },
  {
    id: "sdr",
    label: "SDR",
    path: "/admin/operations/agents/sdr",
    group: "sidebar",
  },
  {
    id: "client-roadmaps",
    label: "Client Roadmaps",
    path: "/admin/operations/client-roadmaps",
    group: "sidebar",
  },
  {
    id: "experiments",
    label: "Experiments",
    path: "/admin/operations/experiments",
    group: "sidebar",
  },
  {
    id: "crm",
    label: "CRM (all)",
    path: "/admin/operations/crm",
    group: "sidebar",
  },
  {
    id: "crm-companies",
    label: "CRM · Companies",
    path: "/admin/operations/crm/companies",
    group: "sidebar",
  },
  {
    id: "crm-people",
    label: "CRM · People",
    path: "/admin/operations/crm/people",
    group: "sidebar",
  },
  {
    id: "crm-deals",
    label: "CRM · Deals",
    path: "/admin/operations/crm/deals",
    group: "sidebar",
  },
  {
    id: "crm-lists",
    label: "CRM · Lists",
    path: "/admin/operations/crm/lists",
    group: "sidebar",
  },
  {
    id: "crm-activity",
    label: "CRM · Activity",
    path: "/admin/operations/crm/activity",
    group: "sidebar",
  },
  {
    id: "agent-console",
    label: "Agent Console",
    path: "/admin/operations/agent-console",
    group: "sidebar",
  },
  {
    id: "investments",
    label: "Investments",
    path: "/admin/operations/investments",
    group: "sidebar",
  },
  {
    id: "finance",
    label: "Finance",
    path: "/admin/operations/finance",
    group: "sidebar",
  },
  { id: "seo", label: "SEO", path: "/admin/operations/seo", group: "sidebar" },
  {
    id: "health",
    label: "Health",
    path: "/admin/operations/health",
    group: "sidebar",
  },
  { id: "me", label: "Me", path: "/admin/operations/me", group: "sidebar" },
  {
    id: "settings",
    label: "Staff Access settings",
    path: "/admin/operations/settings",
    group: "sidebar",
  },
  // Top-level admin routes
  {
    id: "outbound",
    label: "Outbound",
    path: "/admin/outbound-dashboard",
    group: "admin_routes",
  },
  { id: "news", label: "News", path: "/admin/news", group: "admin_routes" },
  {
    id: "templates",
    label: "Templates",
    path: "/admin/templates",
    group: "admin_routes",
  },
  {
    id: "sdr-brain",
    label: "SDR Brain",
    path: "/admin/sdr-brain",
    group: "admin_routes",
  },
  {
    id: "network",
    label: "Network",
    path: "/admin/network",
    group: "admin_routes",
  },
] as const;

export const STAFF_SETTINGS_PATH = "/admin/operations/settings";
